import React from 'react';
import ReactDataGrid from 'react-data-grid';
import _ from 'lodash';
import ReactDOM from 'react-dom';
import { Toolbar, Data } from 'react-data-grid-addons';

import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Input,
} from 'react-bootstrap';
import { reduxForm, formValueSelector, change, Field } from 'redux-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';
import axios from 'axios';
import { fetchSODetailWitSONum, changeStatus } from './action';
import { DatePicker, StartOfThisMonthDatePicker } from '../../../datePicker';

const styles = {
  modal: {
    width: '40%',
    height: '560px',
    marginLeft: '-20%',
    top: '36%',
  },
  container: {
    display: 'flex',
    // alignItems: 'center',
    flexDirection: 'column',
    // justifyContent: 'space-between',
  },
  input: {
    border: '1px solid black',
    marginLeft: '20px',
    width: '190px',
    padding: '2px',
    borderRadius: '5px',
  },
  col: {
    marginTop: '20px',
  },
};

class ShippingStatusEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: props.currentSalesOrderDetail
        ? props.currentSalesOrderDetail.Sales_Order_Lines.map(line => {
          if (line.ProductNum === "01010001") {
            return {
              ...line,
              Quantity: props.currentSalesOrderDetail.TotalOutboundQuantity,
            }
          };
          return line;
        })
        : [],
      defaultDate: new Date(),
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.props.isVisible && prevProps.isVisible) {
      this.setState({
        rows: [...this.props.currentSalesOrderDetail.Sales_Order_Lines].map(line => {
          if (line.ProductNum === "01010001") {
            return {
              ...line,
              Quantity: this.props.currentSalesOrderDetail.TotalOutboundQuantity,
            }
          };
          return line;
        })
      });
    }
  }

  renderTable() {
    const { currentSalesOrderDetail = {} } = this.props;

    const that = this;
    // Parameters of the react-data-grid
    const allRows = Data.Selectors.getRows(this.state);
    const getRows = () => allRows;
    const getSize = () => getRows().length;
    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return Object.assign({ Idx: rowIdx + 1 }, rows[rowIdx]);
    };
    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state, {
        sortColumn,
        sortDirection,
      });
      this.setState(state);
    };

    const handleRowUpdated = (e) => {
      // return;
      const {
        cellKey,
        rowIdx,
        updated: { [cellKey]: value },
      } = e;
      const rows = getRows();
      const filteredRows = this.state.filteredRows;
      let index;
      rows[rowIdx][cellKey] = value;
      this.setState({ rows });
    };

    const isInbound = currentSalesOrderDetail && currentSalesOrderDetail.ShippingStatus === 'Inbound';
    const isPartial = currentSalesOrderDetail && (currentSalesOrderDetail.ShippingStatus === 'Partial_Outbound' || currentSalesOrderDetail.ShippingStatus === 'Outbound')

    const IsVariableFormatter = React.createClass({
      render() {
        return (
          <span>
            <Button
              bsStyle="danger"
              className="textAlignStyle"
              style={{ height: '23px', width: '39px', padding: '0px' }}
              onClick={() => {
                const Index = this.props.dependentValues.Index;
                that.removeRow(Index);
              }}
            >
              X
            </Button>
          </span>
        );
      },
    });
    // Column difinition
    const columns = [
      {
        key: 'Name',
        name: <Translate value="name" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: 'ProductNum',
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: 'RefNo',
        name: <Translate value="FBA_num" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }, {
        key: 'PoNo',
        name: <Translate value="pro_num" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: 'OriginalQuantity',
        name: <Translate value="ordered_qty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      ...((isInbound || isPartial)
        ? [
          {
            key: 'InboundQuantity',
            name: <Translate value="inbound_qty" />,
            resizable: true,
            sortable: true,
            width: 100,
            filterable: true,
          },
        ]
        : {}),
      ...(
        isPartial ? [
          {
            key: 'Quantity',
            name: <Translate value="outbounded_qty" />,
            resizable: true,
            sortable: true,
            width: 110,
            filterable: true,
          },
        ] : {}
      ),
      {
        key: 'qty',
        name: <Translate value="qty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        editable: true,
      },
      ...((isInbound || isPartial)
        ? [{
          key: 'boxQty',
          name: <Translate value="qty_box" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        }]
        : {}),
    ];
    return (
      <Row>
        <Col xs={12}>
          <div className="react-customizer" id="SalesOrderForm-dataGrid3">
            <ReactDataGrid
              rowKey="ProductNum"
              enableCellSelect
              onGridSort={handleGridSort}
              columns={columns}
              rowHeight={25}
              headerRowHeight={45}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              onRowUpdated={handleRowUpdated}
            />
          </div>
        </Col>
      </Row>
    );
  }

  renderHeader = () => <h1>Shipping Status Edit</h1>;

  renderDatePicker = () => {
    return (
      <div style={{ width: '290px' }}>
        <div className="form-group">
          <label className="col-xs-4"><Translate value="operation_date" /></label>
          <div className="col-xs-8">
            <Field name="operationDate" selected={this.state.defaultDate} component={StartOfThisMonthDatePicker} />
          </div>
        </div>
      </div>)
  }

  changeStatus = (e, isPartial, form) => {
    const {
      operationDate = new Date(),
    } = form;
    const { ShippingStatus, SalesOrder_id } = this.props.currentSalesOrderDetail;
    // const shouldAccumulateQty = ShippingStatus === 'Partial_Outbound' || ShippingStatus === 'Outbound';
    const shouldAccumulateQty = false;
    const OrderLines = this.state.rows.map(row => ({
      ProductId: row.Product_id,
      SalesOrderLineId: row.SalesOrderLine_id,
      Qty: (shouldAccumulateQty ? parseFloat(row.qty || 0) + row.Quantity : parseFloat(row.qty)) || 0,
      ...(row.boxQty ? {
        boxQty: parseFloat(row.boxQty),
      } : {}),
    }));

    const payload = {
      OrderLines,
      processDate: operationDate.toISOString(),
    };
    changeStatus(ShippingStatus, SalesOrder_id, payload, isPartial, () => {
      this.props.reloadThePage();
    });
  };

  renderButtons = () => {
    const {
      handleSubmit
    } = this.props;

    const displayText = () => {
      if (!this.props.currentSalesOrderDetail) return 'null';

      const { ShippingStatus } = this.props.currentSalesOrderDetail;

      if (
        ShippingStatus === 'Inbound' ||
        ShippingStatus === 'Partial_Outbound' ||
        ShippingStatus === 'Outbound'
      ) {
        return 'outbound';
      }
      return 'inbound';
    };
    return (
      <ButtonToolbar style={{ marginTop: '20px' }}>
        <Button
          bsStyle="success"
          type="button"
          onClick={handleSubmit(form => this.changeStatus(null, false, form))}
        >
          <Translate value={displayText()} />
        </Button>
        {displayText() === 'outbound' && (
          <Button
            bsStyle="success"
            type="button"
            onClick={handleSubmit(form => this.changeStatus(null, true, form))}
          >
            <Translate value="p-outbound" />
          </Button>
        )}
      </ButtonToolbar>
    );
  };

  render() {
    const { isVisible, onClose, currentSalesOrderDetail, handleSubmit } = this.props;
    const { data } = this.state;

    return (
      <SkyLightStateless
        dialogStyles={styles.modal}
        isVisible={isVisible}
        onCloseClicked={onClose}
      >
        <form onSubmit={handleSubmit}>
          {this.renderHeader()}
          {this.renderDatePicker()}
          {this.renderTable()}
          {this.renderButtons()}
        </form>
      </SkyLightStateless>
    );
  }
}

const mapStateToProps = state => ({
  // vendors: state.vendors.all,
});

const ShippingStatusEditModalWithRedux = reduxForm({
  form: 'ShippingStatusEditModal',
})(ShippingStatusEditModal);

export default ShippingStatusEditModalWithRedux;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/shippingStatusEdit/Modal.jsx